module.exports = __webpack_public_path__ + "795ff3b22c14183f130ecac800276801.pdf";